import useSWR from "swr";
import { User } from "../../features/users/models/user.model";
import { useUserStore } from "../../features/users/store";
import fetcher from "./fetcher";

export const useCurrentUser = () => {
    const { user, setUser } = useUserStore();

    const { data, error, isLoading, mutate } = useSWR(
        "/api/permission-management/v1/users/me",
        (url) => fetcher(url)
    );

    if (data && data.id !== user?.id) {
        setUser(data);
    }

    return {
        user: data as User | undefined,
        isLoading,
        isError: error,
        mutateCurrentUser: mutate,
    };
};
